var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade-out"}},[(_vm.isIndexing)?_c('div',{staticClass:"indexing-container"},[_c('div',{staticClass:"indexing-bar"},[_c('div',{staticClass:"indexing-bar__progress",style:({ width: `${_vm.percentage}%`})})]),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.infoText)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }